// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --padding-normal: 1rem;
  --padding-small: 0.5rem;
  --padding-large: 1.5rem;
  --margin-normal: 1rem;
  --margin-small: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/aware/aware.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":[":root {\n  --padding-normal: 1rem;\n  --padding-small: 0.5rem;\n  --padding-large: 1.5rem;\n  --margin-normal: 1rem;\n  --margin-small: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
